import { render, staticRenderFns } from "./ModalEnviarFornecedor.vue?vue&type=template&id=53477659&scoped=true"
import script from "./ModalEnviarFornecedor.vue?vue&type=script&lang=js"
export * from "./ModalEnviarFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53477659",
  null
  
)

export default component.exports